import { api } from "utils/api";
import type { User } from "../types";

const getProfile = () => api.get<User>("/profile", { requireAuth: true });

export { getProfile };
